/**
 * Clarix Type Definitions
 * Central type store for backend backbone
 */

// Environment Types
export interface RuntimeEnv {
  pbUrl: string
  collectionOverrides: Partial<Record<string, string>>
  appEnv: 'development' | 'staging' | 'production'
  logLevel: 'debug' | 'info' | 'warn' | 'error'
  appVersion: string
  buildTime: string
  features: FeatureFlags
}

export interface FeatureFlags {
  offlineQueue: boolean
  errorTracking: boolean
  performanceMonitoring: boolean
}

// PocketBase Client Types
export interface PBAuthRecord {
  id: string
  email: string
  emailVisibility: boolean
  verified: boolean
  created: string
  updated: string
  collectionId: string
  collectionName: string
  [key: string]: unknown
}

export interface PBListOptions {
  page?: number
  perPage?: number
  sort?: string
  filter?: string
  skipTotal?: boolean
}

export interface PBListResult<T> {
  page: number
  perPage: number
  totalItems: number
  totalPages: number
  items: T[]
}

// Error Types
export enum ErrorCode {
  NETWORK_ERROR = 'NETWORK_ERROR',
  AUTH_ERROR = 'AUTH_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',
  SERVER_ERROR = 'SERVER_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export interface ClarityError extends Error {
  code: ErrorCode
  statusCode?: number
  context?: Record<string, unknown>
}

// Offline Queue Types
export interface OfflineQueueItem {
  id: string
  operation: 'CREATE' | 'UPDATE' | 'DELETE'
  collection: string
  recordId: string
  data: Record<string, unknown>
  timestamp: number
  retries: number
  lastError?: string
}

export interface OfflineQueueState {
  items: OfflineQueueItem[]
  isSyncing: boolean
  lastSyncTime: number | null
  syncErrorCount: number
}

// Domain Service Types (Skeleton)
export interface ClarityUser {
  id: string
  email: string
  name: string
  created: string
  updated: string
}

export interface ServiceContext {
  userId: string | null
  isAuthenticated: boolean
  offline: boolean
}
